import React, {useEffect, useState} from 'react';
import {Dialog} from '@material-ui/core';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory, useLocation} from 'react-router-dom';
import DialogBody from 'components/DialogBody/styles';
import NewOrderImageGif from 'assets/bell_red.gif';
import DialogTitle from 'components/DialogTitle/styles';
import {DialogAction} from 'routes/App/dashboard/styles';
import {ButtonPrimary} from 'components/buttons';
import {SuccessImageOrder} from 'routes/App/account/styles';
import DialogClose from 'components/DialogClose/styles';
import DialogContainer from 'components/DialogContainer/styles';
import {
  CLEAR_NEW_ORDERS,
  RUN_GET_ACTIVE_ORDERS_JOB,
  SET_ACTIVE_EVENT_ORDERS,
  STOP_GET_ACTIVE_ORDERS_JOB
} from 'store/global/ordersV2/action';
import {EVENT_ORDER_TYPE_SELECT} from 'helpers/constants/orders_v2';

const GoToAllOrdersButton = ({onClose, history}) => {
  return (
    <ButtonPrimary
      onClick={() => {
        onClose();
        history.push('/orders-v2');
      }}
    >
      <span>Go to Active Orders</span>
    </ButtonPrimary>
  );
};

GoToAllOrdersButton.propTypes = {
  onClose: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
};

const GoBackToAllOrdersButton = ({onClose}) => {
  return (
    <ButtonPrimary
      onClick={() => {
        onClose();
      }}
    >
      <span>Go Back to Active Orders</span>
    </ButtonPrimary>
  );
};

GoBackToAllOrdersButton.propTypes = {
  onClose: PropTypes.func.isRequired
};

const NewOrderModalV2 = ({play, onSoundStop}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {pathname} = useLocation();
  const [gif, setGif] = useState(null);
  const onOrdersPage = pathname === '/orders-v2/active';
  const {newOrders} = useSelector((state) => state.activeOrdersV2Reducer);
  const openSuccessModal = useSelector(
    (state) => state.bookADriverCreateReducer.openSuccessModal
  );
  const RingOnTablet = useSelector(
    (state) => state.user.userData?.RingOnTablet
  );
  const {userData} = useSelector((state) => state.user);
  const serviceFeatures = useSelector(
    (state) => state.user.activeLocation.AllowedServiceFeatures
  );
  const {length} = newOrders || [];

  useEffect(() => {
    if (length) {
      setGif(NewOrderImageGif);
    } else setGif(null);
  }, [length]);

  const onNotificationRing = () => {
    const ring = RingOnTablet;

    if (newOrders.length > 0) {
      if (ring) {
        play();
      }
    }
  };

  useEffect(() => {
    onNotificationRing();
  }, [newOrders]);

  const onClose = () => {
    onSoundStop();
    dispatch(CLEAR_NEW_ORDERS());
    dispatch(STOP_GET_ACTIVE_ORDERS_JOB());
    dispatch(RUN_GET_ACTIVE_ORDERS_JOB({onPollAction: onSoundStop}));
  };

  return (
    <Dialog
      open={length > 0 && !openSuccessModal}
      scroll='body'
      onClose={onClose}
    >
      <DialogContainer className='DialogM DialogDark'>
        <DialogClose onClick={onClose} className='white' />
        <DialogBody>
          <SuccessImageOrder>
            <span>{length}</span>
            <img src={gif} alt='' />
          </SuccessImageOrder>
          <DialogTitle className='marginBottomXs Xl'>
            {`You have ${length} new order${length > 1 ? 's' : ''}!`}
          </DialogTitle>
          <DialogAction>
            {onOrdersPage ? (
              <GoBackToAllOrdersButton onClose={onClose} />
            ) : (
              <GoToAllOrdersButton onClose={onClose} history={history} />
            )}
          </DialogAction>
        </DialogBody>
      </DialogContainer>
    </Dialog>
  );
};

NewOrderModalV2.propTypes = {
  play: PropTypes.func.isRequired,
  onSoundStop: PropTypes.func.isRequired
};

export default NewOrderModalV2;
